import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@core/services/auth/auth.service';
import { Paths } from '@shared/enums/paths.enums';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.authService.isLoggin()) {
      this.router.navigate([Paths.login], { queryParams: { returnUrl: state.url } });
      return false;
    }

    return true;
  }
}
